// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__JIdBz","title":"Header_title__363ZA","left":"Header_left__1JoVq","clinicName":"Header_clinicName__odpH_"};